import o from "./isFunction.js";
import e from "./_isMasked.js";
import a from "./isObject.js";
import n from "./_toSource.js";
var p = /[\\^$.*+?()[\]{}|]/g, i = /^\[object .+?Constructor\]$/, s = Function.prototype, c = Object.prototype, f = s.toString, m = c.hasOwnProperty, u = RegExp(
  "^" + f.call(m).replace(p, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function O(r) {
  if (!a(r) || e(r))
    return !1;
  var t = o(r) ? u : i;
  return t.test(n(r));
}
export {
  O as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_baseIsNative.js
// module id = 1476
// module chunks = 67